import { Component, type ErrorInfo, type ReactNode } from 'react'

type Props = {
  children: ReactNode
}

type State = {
  error: Error | null
}

export class AppErrorBoundary extends Component<Props, State> {
  state: State = { error: null }

  static getDerivedStateFromError(error: Error): State {
    return { error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Swell AI runtime failure', error, info)
  }

  render() {
    if (!this.state.error) {
      return this.props.children
    }

    return (
      <main
        style={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          padding: '2rem',
          background: '#F7F7F5',
          fontFamily: 'Inter, ui-sans-serif, system-ui, sans-serif',
          color: '#000000',
        }}
      >
        <section
          style={{
            width: 'min(680px, 100%)',
            background: '#FFFFFF',
            border: '1px solid #000000',
            borderTop: '4px solid #FF2D6F',
            padding: '2rem',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '.8rem', marginBottom: '1.6rem' }}>
            <img src="/brand/fifthwave-mark.svg" alt="" aria-hidden="true" width="40" height="40" />
            <div>
              <strong style={{ display: 'block' }}>Swell AI</strong>
              <span style={{ color: '#6E6E6E', fontSize: '.7rem', letterSpacing: '.08em', textTransform: 'uppercase' }}>
                A Fifthwave Digital product
              </span>
            </div>
          </div>
          <p style={{ margin: 0, fontWeight: 700, letterSpacing: '.1em', fontSize: '.72rem', textTransform: 'uppercase', color: '#6E6E6E' }}>
            Application error
          </p>
          <h1 style={{ margin: '.6rem 0', letterSpacing: '-.04em' }}>The application could not start</h1>
          <p style={{ lineHeight: 1.6 }}>
            The deployed application encountered a configuration or runtime error before the workspace could load.
          </p>
          <pre
            style={{
              whiteSpace: 'pre-wrap',
              overflowWrap: 'anywhere',
              padding: '1rem',
              background: '#F7F7F5',
              border: '1px solid #BDBDBD',
            }}
          >
            {this.state.error.message}
          </pre>
          <p style={{ marginBottom: 0, lineHeight: 1.6 }}>
            Refresh after the deployment configuration has been corrected.
          </p>
        </section>
      </main>
    )
  }
}
